'use strict';

import { dimensions } from './dimensions';
import smoothScroll from './smooth-scroll';
import { isMobile } from './device';
import { getHeader, getSearchForm, isPersistentSearch } from './header-utils';

export const header = getHeader();
export const stickyHeader = document.querySelector('.sticky-header');
export const persistentSearch = isPersistentSearch();
export const searchForm = getSearchForm();

const headerPeepThreshold = 116;
export const scrollBuffer = 0;

function scrollToElement(element, verticalOffset, speed) {
  let scrollPosition = 0;

  let elementOffset = dimensions.getVerticalPosition(element);

  if (verticalOffset) {
    elementOffset += verticalOffset;
  }

  if (header) {
    if (headerWillStick(elementOffset)) {
      scrollPosition = elementOffset - getStickyHeaderHeight(elementOffset) - scrollBuffer;
    } else {
      scrollPosition = elementOffset - scrollBuffer;
    }

    if (scrollPosition < 0) {
      scrollPosition = 0;
    }
  }


  if (persistentSearch && isMobile()) {
    scrollPosition = scrollPosition - (getPersistentSearchHeight() - (scrollBuffer * 1.25));
  }

  scrollPosition = scrollPosition - stickyATBHeight(elementOffset);
  
  const scrollAmount = scrollPosition - window.scrollY;

  if (scrollAmount < headerPeepThreshold && isMobile()) {
    scrollPosition -= 48;
  }

  smoothScroll(scrollPosition, speed);
}

export function getStickyHeaderHeight(scrollToPosition) {
  if (!stickyHeader) {
    return 0;
  }

  const stickyHeaderHeight = dimensions.getElementHeight(stickyHeader, true);

  // reduce the returned header height by the difference in header height
  // at the top of the page, versus when the user has scrolled down.
  if (isMobile() && 
    scrollToPosition > headerPeepThreshold && 
    window.scrollY < headerPeepThreshold) 
  {
    // return stickyHeaderHeight - 99;
    return 69;
  }

  return stickyHeaderHeight;
}

function getHeaderHeight() {
  return dimensions.getElementHeight(header, true);
}

function getPersistentSearchHeight() {
  return persistentSearch ? dimensions.getElementHeight(searchForm, true) : 0;
}

function stickyATBHeight(elementOffset) {
  const stickyATB = document.querySelector('.sticky-add-to-basket');
  const addToBasketButton = document.querySelector('.add-to-basket-summary-and-cta button');

  if (!stickyATB || !addToBasketButton) {
    return 0;
  }

  const addToBasketButtonOffset = dimensions.getVerticalPosition(addToBasketButton);

  if (elementOffset < addToBasketButtonOffset) {
    return 0;
  }

  return dimensions.getElementHeight(stickyATB, true);
}

function headerWillStick(elementOffset) {
  let headerHeight = getHeaderHeight();
  let stickyHeaderHeight = getStickyHeaderHeight();
  let safeZone = Math.max(0, headerHeight - stickyHeaderHeight - scrollBuffer);
  return elementOffset - scrollBuffer > safeZone ? true : false;
}

export default scrollToElement;
